import { DealPipelineStatus } from '@assets/model/Store';
import classNames from 'classnames';
import * as style from './DealStatusBadge.module.less';
import iconNotStarted from './icon_not_started.svg';
import iconModulesRun from './icon_modules_run.svg';
import iconModulesCompleted from './icon_modules_completed.svg';
import iconNarrativeGenerated from './icon_narrative_generated.svg';

interface IDealStatusBadgeProps {
    status: DealPipelineStatus;
}

export const DealStatusBadge = (p: IDealStatusBadgeProps) => {
    const { stage, completed, total } = p.status;

    let label: string;
    let icon: string;
    let variant: string;

    switch (stage) {
        case 'narrative_generated':
            label = 'Narrative generated';
            icon = iconNarrativeGenerated;
            variant = style.narrative;
            break;
        case 'modules_completed':
            label = 'Modules completed';
            icon = iconModulesCompleted;
            variant = style.completed;
            break;
        case 'modules_run':
            label = `Modules run (${completed}/${total})`;
            icon = iconModulesRun;
            variant = style.running;
            break;
        case 'not_started':
        default:
            label = 'Not started';
            icon = iconNotStarted;
            variant = style.notStarted;
            break;
    }

    return (
        <div className={classNames(style.badge, variant)}>
            <img src={icon} className={style.icon} />
            <span>{label}</span>
        </div>
    );
};
